// Cloudflare appends this parameter to the URL it serves its challenge page at.
// A challenged visitor navigates from that page to the destination, so the
// browser reports the challenge URL as `document.referrer` and the original
// referrer is lost client side. Cloudflare still forwards the original `Referer`
// header to our origin, so `_document.tsx` injects it as `window.serverReferrer`
// for us to substitute back in.
const CHALLENGE_TOKEN_PARAM = "__cf_chl_tk";

export const wasChallenged = (documentReferrer: string): boolean =>
  documentReferrer.includes(CHALLENGE_TOKEN_PARAM);

type Referrers = {
  /** What the browser reports, which a challenge will have overwritten. */
  documentReferrer: string;
  /** What our origin received, which a challenge leaves intact. */
  serverReferrer: string | null | undefined;
};

export const effectiveReferrer = ({
  documentReferrer,
  serverReferrer,
}: Referrers): string =>
  wasChallenged(documentReferrer) && serverReferrer
    ? serverReferrer
    : documentReferrer;
